import React from "react";
import { Link } from "react-router-dom";
import brand from "../spec/brand";

const year = 2026;

const Footer = () => (
  <footer className="footer">
    <div className="workbench">
      <div className="footer__top">
        <div>
          <img className="footer__mark-logo" src="/brand/ftd-logo.png" alt={brand.name} />
          <p className="footer__tagline">
            {brand.tagline} A small senior engineering studio in {brand.hq.city}, working with operators
            across the region.
          </p>
        </div>

        <div className="footer__col">
          <div className="footer__col-head">Studio</div>
          <ul>
            <li><Link to="/#craft">Craft</Link></li>
            <li><Link to="/#practice">Practice</Link></li>
            <li><Link to="/#sectors">Sectors</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <div className="footer__col-head">Office</div>
          <ul>
            <li>{brand.hq.address.line1}</li>
            <li>{brand.hq.address.line2}</li>
            <li>{brand.contact.hours}</li>
          </ul>
        </div>

        <div className="footer__col">
          <div className="footer__col-head">Direct</div>
          <ul>
            <li><a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a></li>
            <li><a href={`mailto:${brand.contact.finance}`}>{brand.contact.finance}</a></li>
          </ul>
        </div>
      </div>
      <div className="footer__bottom">
        <span>© {year} {brand.name}. All rights reserved.</span>
        <span>{brand.domain} · Engineering studio</span>
      </div>
    </div>
  </footer>
);

export default Footer;
